import axios from "../../js/project-axios.js"

const list = productIds => {
    return axios.get("/positionRecord/list", {
        params: {
            productId: productIds
        }
    });
};

const add = positionRecords => {
    return axios.post("/positionRecord/add", positionRecords);
};

export default {
    list,
    add
};